// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"896d0c002226e53b","6831":"0022c910f268c8ff","8503":"3927584e896abae7","9683":"ad981b5fca8b01b8"}[chunkId] + ".js";
};